export const ErrorCode = {
  Success: 0,
  NotExistAccount: 10001, //ユーザー存在しない
  InvalidToken: 10002, //Token無効
  ServerError: 99999,
};

export const StatusCode = {
  Unauthorized: 401,
  Forbidden: 403,
};
